import { computed } from '@angular/core';
import { signalStoreFeature, type, withComputed } from '@ngrx/signals';
import { remove as removeDiac } from 'diacritics';

import { RessourceState } from './ressource.state';

export function avecSélecteursRessources() {
  return signalStoreFeature(
    { state: type<RessourceState>() },
    withComputed(({ filtre, ressources }) => ({
      connaissances: computed(() =>
        ressources()
          .filter((e) => e.type === 'Connaissance')
          .filter((e) => removeDiac(e.nom.toLowerCase()).includes(removeDiac(filtre()))),
      ),
      documentations: computed(() =>
        ressources()
          .filter((e) => e.type === 'Documentation')
          .filter((e) => removeDiac(e.nom.toLowerCase()).includes(removeDiac(filtre()))),
      ),
      materiels: computed(() =>
        ressources()
          .filter((e) => e.type === 'Matériel')
          .filter((e) => removeDiac(e.nom.toLowerCase()).includes(removeDiac(filtre()))),
      ),
      habiletes: computed(() =>
        ressources()
          .filter((e) => e.type === 'Habileté')
          .filter((e) => removeDiac(e.nom.toLowerCase()).includes(removeDiac(filtre()))),
      ),
      ressourcesTriées: computed(() => {
        const interrelations = ressources();
        interrelations.sort((a, b) => a.nom.localeCompare(b.nom));
        return interrelations;
      }),
    })),
  );
}
